import React from 'react';

export function parseMultiselectValue(value: unknown): string[] | null {
  if (value === null || value === undefined || value === '') return [];
  if (typeof value !== 'string') return null;
  try {
    const parsed: unknown = JSON.parse(value);
    return Array.isArray(parsed) && parsed.every(item => typeof item === 'string')
      ? parsed : null;
  } catch {
    return null;
  }
}

type Props = {
  labels: string[];
  value: unknown;
  size?: [number, number];
  lineItems?: number;
  compact?: boolean;
  disabled?: boolean;
  onChange?: (value: string) => void;
};

export default function MultiselectButtons({ labels, value, size, lineItems, compact = false, disabled = false, onChange }: Props) {
  const selected = parseMultiselectValue(value);
  if (!selected || selected.some(label => !labels.includes(label))) {
    return <span className="spread-multiselect-error" title={String(value ?? '')}>選択配列が不正です</span>;
  }
  const selectedSet = new Set(selected);
  const itemsPerRow = !compact && lineItems && lineItems > 0 ? lineItems : labels.length;
  const rows = Array.from({ length: Math.ceil(labels.length / itemsPerRow) }, (_, index) =>
    labels.slice(index * itemsPerRow, (index + 1) * itemsPerRow));
  return (
    <div className={`spread-multiselect${compact ? ' spread-multiselect-compact' : ''}`}>
      {rows.map((row, rowIndex) => (
        <div
          key={rowIndex}
          className="spread-multiselect-row"
          style={!compact && size && lineItems ? {
            width: row.length * size[0] + (row.length - 1) * 4,
          } : undefined}
        >
          {row.map(label => (
            <button
              key={label}
              type="button"
              className={`spread-multiselect-button${selectedSet.has(label) ? ' is-selected' : ''}`}
              style={!compact && size ? { width: size[0], height: size[1] } : undefined}
              aria-pressed={selectedSet.has(label)}
              disabled={disabled || !onChange}
              onClick={event => {
                event.stopPropagation();
                onChange?.(JSON.stringify(labels.filter(item => item === label ? !selectedSet.has(item) : selectedSet.has(item))));
              }}
            >{label}</button>
          ))}
        </div>
      ))}
    </div>
  );
}
